module.exports = __webpack_public_path__ + "static/media/frozen.89649e61.jpg";